import React, {Component} from 'react';
import TextProperties from '../Properties/TextProperties'
import BarcodeProperties from '../Properties/BarcodeProperties'
import PictureProperties from '../Properties/PictureProperties'
import TableProperties from '../Properties/TableProperties'
import ChartProperties from '../Properties/ChartProperties'
import ElementProps from '../ElempentProps';
import objeler from '../objeler';
import ModalBase from './ModaBase';

class ModalDialog extends Component<props> {
    constructor(props) {
        super(props);
        this.state = {ElementProps};
    }

    closeModal = (e, b) => {
        if (b === "OK")
            this.props.closeModal(objeler.tarik);
        else
            this.props.closeModal("Cancel");
    }

    render() {
        return (
            <div>
                <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.props.closeModal}
                    title={'Properties'}
                >
                    <table className="ta ble" height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                {this.props.ElementProps.color}
                                {
                                    (() => {
                                        switch (this.props.ElementProps.Type) {
                                            case 'TextBox':
                                            case 'Word':
                                                return <TextProperties type={this.props.ElementProps.Type}/>;
                                            case 'Barcode':
                                                return <BarcodeProperties type={this.props.ElementProps.Type}/>;
                                            case 'Picture':
                                            case 'Signature':
                                            case 'Lines':
                                            case 'Rectangle':
                                            case 'Ellipse':
                                                return <PictureProperties type={this.props.ElementProps.Type}/>;
                                            case 'Table':
                                                return <TableProperties type={this.props.ElementProps.Type}/>;
                                            case 'Chart':
                                                return <ChartProperties type={this.props.ElementProps.Type}/>;
                                            default:
                                                return null;
                                        }
                                    }).call(this)
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>
            </div>
        );
    }
}

export default ModalDialog